export default class SubscriptionListController {
    constructor(clientService, userService, channelsService, subscriptionsService, $location) {
        this.$location = $location;

        userService.getAdmins().then(resp => {
            this.users = resp.data;
        });

        channelsService.getBySubscriptionId().then(resp => {
            this.channels = resp.data;
        });

        clientService.getAll().then(resp => {
            this.clients = resp.data;
        });

        subscriptionsService.getSubscriptions().then(resp => {
            this.subscriptions = resp.data;
        });
    }

    edit(id){
       this.$location.path("/manage/user/edit/" + id);
    }

    editSub(id){
        this.$location.path("/manage/subscriptions/edit/" + id);
     }

     viewCredits(id){
        this.$location.path("/manage/credits/" + id);
     }

     

    editChannel(id){
        this.$location.path("/manage/channels/" + id);
     }

     deleteSub(id)
     {

     }
}



// WEBPACK FOOTER //
// ./src/js/components/subscriptions/subscriptions.list.controller.js